import { render, staticRenderFns } from "./ProductDesign2ViewArticle.vue?vue&type=template&id=214f5094&"
import script from "./ProductDesign2ViewArticle.vue?vue&type=script&lang=js&"
export * from "./ProductDesign2ViewArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports